'use strict';

import minicart from '../minicart';

var bambuser = {
	init: function () {
		const basketPLIs = {};
		/**
		 * triggers the frontend minicart update
		 * this will likely need to be customized for each shop frontend client
		 * @param {number} cartState.quantityTotal total cart quantity
		 * @param {string} cartState.minicartCountOfItems string description of cart quantity
		 */
		function updateShopMiniCart({ quantityTotal, minicartCountOfItems }) {
			window.$('.minicart').trigger('count:update', { quantityTotal, minicartCountOfItems });
			document.dispatchEvent(new Event('cart:update', { bubbles: true }));
		}
	
		/**
		 * updates bambuser player with product data
		 * @param {Object} productResponse product data retrieved from sfra
		 * @param {Object} player bambuser player instance
		 * @param {Object} config module config object
		 * @returns {void}
		 */
		function updateBambuserProduct(productResponse, player) {			    
			if (productResponse) {
				player.updateProduct(productResponse.bambuserPID, factory => factory
						.currency(window.User.currencyCode)
						.locale(window.User.locale)
						.product(p => p
								.brandName(productResponse.brand)
								.defaultVariationIndex(0)
								.description(productResponse.description)
								.name(productResponse.name)
								.sku(productResponse.id)
								.variations(v => productResponse.variations.map(variation =>
								v()                    
								.attributes(a => a
										.colorName(variation.colorName)
										.colorHexCode(variation.colorHexCode))
										.imageUrls(variation.imageURLs)
										.name(variation.name)
										.sku(variation.sku)
										.sizes(s => variation.sizes.map(size =>
										s()                            
										.name(size.name)
										.inStock(size.inStock)
										.price(pr => pr
												.currency(size.price.currency)
												.current(size.price.current)
										)
										.sku(size.sku)
										)
										)
								)
								)
						)
				);
	
			}
		}
	
	
		window.onBambuserLiveShoppingReady = function(player) {      
	
			player.configure({
				locale: window.User.locale,
				currency: window.User.currencyCode,
			});
	
	
			// handle add to cart
			player.on(player.EVENT.ADD_TO_CART, (addedItem, callback) => {
				var csrf_token = $('meta[name="csrf-token"]').attr('content');	
				const payLoad = new FormData();
				payLoad.append('pid', addedItem.sku);
				payLoad.append('format', 'ajax');
				payLoad.append(Constants.CSRF_TOKEN_NAME, csrf_token);
				payLoad.append('Quantity', addedItem.quantity || 1);
				window.fetch(
						window.Urls.addProduct,
						{
							method: 'POST',
							body: payLoad,
						})
						.then((response) => response.text())
						.then((responsetxt) => {
							var response = responsetxt;
							try {
								responsetxt = responsetxt.trim();
								responsetxt = JSON.parse(responsetxt);
								if (responsetxt.success === false) {
									callback({
										success: false,
										reason: "custom-error",
										message: responsetxt.error, //edit this by your choice
									});
									return ;
								}
							} catch (e) {
								basketPLIs[addedItem.sku] = addedItem.sku;
								minicart.show(response);
								// updateShopMiniCart(productJson);
								callback(true);
							}
						});
			});
	
			// handle checkout (redirect)
			player.on(player.EVENT.CHECKOUT, () => {
				window.location.assign(Urls.cartRedesignShow);
			});
	
			// handle PROVIDE_PRODUCT_DATA
			player.on(player.EVENT.PROVIDE_PRODUCT_DATA, (event) => {
				Array.prototype.forEach.call(event.products, (prod) => {
					// construct query url
					const url = new URL(window.location.href);
					url.pathname = window.Urls.bambuserProduct;
					url.searchParams.append('id', prod.id || '');
					url.searchParams.append('ref', prod.ref || '');
	
					// fetch and process product data
					window.fetch(url, { method: 'GET' })
					.then((response) => response.json())
					.then((responseObj) => updateBambuserProduct(responseObj.product, player));
				});
			});
	
			// Optional: handle CLOSE
			player.on(player.EVENT.CLOSE, (event) => { // eslint-disable-line no-unused-vars
				// do something
			});
	
			// handle SYNC_CART_STATE
			player.on(player.EVENT.SYNC_CART_STATE, (event) => { // eslint-disable-line no-unused-vars
				// Currently, update cart does not support anything more than emptying the cart.
				// The Bambuser team is working on providing a way to fully control the in-player cart.
				// For a consistent UX, this event should sync the player minicart with the shop cart
				// on launch
			});
	
			// handle UPDATE_ITEM_IN_CART
			// Note: due to the possibility of the player cart being out of sync with the shop, some unexpected behavior
			// is possible (see SYNC_CART_STATE handler)
			player.on(player.EVENT.UPDATE_ITEM_IN_CART, (updatedItem, callback) => {
				const pliUUID = basketPLIs[updatedItem.sku];
	
				if (pliUUID) {
					var qty = updatedItem.quantity - updatedItem.previousQuantity;
					var urlRedirect = window.Urls.addProduct;
	
					var csrf_token = $('meta[name="csrf-token"]').attr('content');	
					const payLoad = new FormData();
					payLoad.append('pid', updatedItem.sku);
					payLoad.append('format', 'ajax');
					payLoad.append(Constants.CSRF_TOKEN_NAME, csrf_token);
					payLoad.append('Quantity', qty);
					payLoad.append('cartAction', 'update');
					payLoad.append('replenishmentCycle', 0);
					window.fetch(
							urlRedirect,
							{
								method: 'POST',
								body: payLoad,
							})
							.then((response) => response.text())
							.then((responsetxt) => {
								var response = responsetxt;
								try {
									responsetxt = responsetxt.trim();
									responsetxt = JSON.parse(responsetxt);
									if (responsetxt.success === false) {
										callback({
											success: false,
											reason: "custom-error",
											message: responsetxt.error, //edit this by your choice
										});
										return ;
									}
								} catch (e) {
									basketPLIs[pliUUID] = pliUUID;
									minicart.show(response);
									// updateShopMiniCart(productJson);
									callback(true);
								}
							});
	
				} else {
					callback(false);
				}
			});
		};
	
	}
}

export default bambuser;